import type {
  ColumnSelectOption,
  EditableColumnDef,
  EditableRow,
} from '../types';

export function patchField(
  row: EditableRow,
  fieldId: string,
  value: string
): EditableRow {
  return {
    ...row,
    fields: { ...row.fields, [fieldId]: value },
  };
}

/** Radix Select `value` must match a `SelectItem`; blank or unknown maps to the first option. */
export function selectValueForOptions(
  raw: string | undefined,
  options: ColumnSelectOption[]
): string {
  const trimmed = (raw ?? '').trim();
  if (trimmed === '') {
    return options[0]?.value ?? '';
  }
  const allowed = new Set(options.map(o => o.value));
  return allowed.has(trimmed) ? trimmed : (options[0]?.value ?? trimmed);
}

export function summaryText(col: EditableColumnDef, row: EditableRow): string {
  const raw = row.fields[col.id] ?? '';
  if (col.kind === 'select' && col.options) {
    const v = selectValueForOptions(raw, col.options);
    const opt = col.options.find(o => o.value === v);
    return opt?.label ?? v;
  }
  const t = raw.trim();
  /** Empty text columns are wildcards — show `*` in collapsed summary (KIR-2048). */
  return t === '' ? '*' : t;
}
